import { chakra } from '@aloft/toolkit-sui/chakra';

import { getPinnedRowStyles } from '../getPinnedRowStyles.js';
import { getRowStyles } from '../getRowStyles.js';
import { RowProps } from '../types.js';
import { Cell } from './Cell.js';

export function Row<T>({
  id,
  row,
  activeRowIndex,
  shouldPinFirstRow,
  handleRowClick,
  enableHoverStyle,
  pinnedColumnStyles,
  isSelected,
  customBackgroundColor,
}: RowProps<T>) {
  if (!row) return null;

  const isActive = row.index === activeRowIndex;

  return (
    <chakra.tr
      id={id}
      {...getPinnedRowStyles(shouldPinFirstRow, row.index)}
      onClick={() => handleRowClick(row)}
      sx={getRowStyles(isActive, !!isSelected, enableHoverStyle, customBackgroundColor)}
    >
      {row.getVisibleCells().map((cell) => (
        <Cell
          key={'cell-' + cell.id}
          cell={cell}
          shouldPinFirstRow={shouldPinFirstRow}
          pinnedColumnStyles={pinnedColumnStyles}
          rowIndex={row.index}
        />
      ))}
    </chakra.tr>
  );
}
